import React, { FC } from 'react'
import { ProductModule } from '../types'
import { useProductContext } from '../../../contexts/product'
import { ProductUSPContent } from './ProductUSPContent'
import { useExperiment } from '@moonpig/web-core-eppo/browser'

export const USPModule: FC<ProductModule> = props => {
  const [{ product }] = useProductContext()
  const usps = product.usps?.items || []

  const productUsps = useExperiment('attach-product-usps', {
    fallback: 'control',
  })

  if (productUsps === 'control' || usps.length === 0) {
    return null
  }

  return <ProductUSPContent {...props} usps={usps} />
}
